"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeValueHandlerAdapter_1 = require("./NodeValueHandlerAdapter");
/**
 * Converts GraphQL variables to terms based on the contents of the variablesDict.
 */


var NodeValueHandlerVariable =
/*#__PURE__*/
function (_NodeValueHandlerAdap) {
  _inherits(NodeValueHandlerVariable, _NodeValueHandlerAdap);

  function NodeValueHandlerVariable(util, settings) {
    _classCallCheck(this, NodeValueHandlerVariable);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeValueHandlerVariable).call(this, 'Variable', util, settings));
  }

  _createClass(NodeValueHandlerVariable, [{
    key: "handle",
    value: function handle(valueNode, fieldName, convertContext) {
      var id = valueNode.name.value;
      var value = convertContext.variablesDict[id];
      var meta = convertContext.variablesMetaDict[id]; // Handle missing values

      if (!value) {
        if (!convertContext.ignoreUnknownVariables && (!meta || meta.mandatory)) {
          throw new Error("Undefined variable: ".concat(id));
        } else {
          var variable = this.util.dataFactory.variable(id);

          if (convertContext.terminalVariables.map(function (v) {
            return v.value;
          }).indexOf(id) < 0) {
            convertContext.terminalVariables.push(variable);
          }

          return {
            terms: [variable]
          };
        }
      } // Don't allow variables that refer to other variables


      if (value.kind === 'Variable') {
        throw new Error("Variable refers to another variable: ".concat(id));
      }

      if (meta) {
        // Check the type
        if (meta.list) {
          // If we expect a list, check if we got a list.
          if (value.kind !== 'ListValue') {
            throw new Error("Expected a list, but got ".concat(value.kind, " for ").concat(id));
          } // Check the type in the list


          if (meta.type) {
            var listValue = value;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = listValue.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var v = _step.value;

                if (v.kind !== meta.type) {
                  throw new Error("Expected ".concat(meta.type, ", but got ").concat(v.kind, " for ").concat(id));
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
        } else if (meta.type) {// This is allowed to be different (?)

          /*if (value.kind !== meta.type) {
            throw new Error(`Expected ${meta.type}, but got ${value.kind} for ${id}`);
          }*/
        }
      }

      return this.util.handleNodeValue(value, fieldName, convertContext);
    }
  }]);

  return NodeValueHandlerVariable;
}(NodeValueHandlerAdapter_1.NodeValueHandlerAdapter);

exports.NodeValueHandlerVariable = NodeValueHandlerVariable;